import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GCADANavigationService } from '@GCADA/components/navigation/navigation.service';

@Component({
    selector: 'GCADA-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GCADANavigationComponent implements OnInit {

    @Input() layout = 'vertical';

    @Input() navigation: any;

    public navList: Array<any> = [];

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {GCADANavigationService} _GCADANavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _GCADANavigationService: GCADANavigationService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
    */
    ngOnInit(): void {
        //Load Navigation menu
        this.getNavMenuList();

        // Load the navigation either from the input or from the service
        this.navigation = this.navigation || this._GCADANavigationService.getCurrentNavigation();

        // Subscribe to the current navigation changes
        this._GCADANavigationService.onNavigationChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {

            // Load the navigation
            this.navigation = this._GCADANavigationService.getCurrentNavigation();

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });

        // Subscribe to navigation item
        merge(
            this._GCADANavigationService.onNavigationItemAdded,
            this._GCADANavigationService.onNavigationItemUpdated,
            this._GCADANavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    //Get nav menu list
    getNavMenuList() {
        this._GCADANavigationService.getnavList().then((data) => {
            if (data) {
                this.navList = data;
                if (this.navigation.length > 0 && this.navList.length > 0) {
                    this.navigation[0].children.forEach((elementLeftNav, index) => {
                        if (elementLeftNav.id == "departments") {
                            let navMenuAvailItem = this.navList.find(x => x.label == elementLeftNav.title);
                            this.addMenuInNavigationChild(navMenuAvailItem, index);
                        } else if (elementLeftNav.id == "legalregulatory") {
                            let navMenuAvailItem = this.navList.find(x => x.label == elementLeftNav.title);
                            this.addMenuInNavigationChild(navMenuAvailItem, index);
                        }
                    });
                }

            } else {
                this.navList = [];
            }

            setTimeout(() => {
                // require to be updated
                this._changeDetectorRef.markForCheck();
            }, 2000);
        }).catch((error) => {
            this.navList = [];

            setTimeout(() => {
                // require to be updated
                this._changeDetectorRef.markForCheck();
            }, 2000);
        })
    }

    //Add menu in navigation childern
    addMenuInNavigationChild(navMenuAvailItem, index) {
        if (navMenuAvailItem) {
            if (navMenuAvailItem.childs.length > 0) {
                navMenuAvailItem.childs.forEach((element, parentIndex) => {
                    let pageLabelId = element.label.toString().toLowerCase().trim().replace(/[^A-Z0-9]+/ig, '-');
                    if (element.childs.length > 0) {
                        this.navigation[0].children[index].children.push({
                            id: pageLabelId,
                            title: element.label,
                            type: 'collapsable',
                            children: []
                        });

                        //Nav menu node child
                        element.childs.forEach((elementChild, childIndex) => {
                            let pageLabelId = elementChild.label.toString().toLowerCase().trim().replace(/[^A-Z0-9]+/ig, '-');
                            this.navigation[0].children[index].children[parentIndex].children.push({
                                id: pageLabelId,
                                title: elementChild.label,
                                type: 'item',
                                openInNewTab: true,
                                url: '/pages/content/' + pageLabelId + '/' + navMenuAvailItem.id + '/' + element.id + '/' + elementChild.id
                            });
                        });

                    } else {
                        this.navigation[0].children[index].children.push({
                            id: pageLabelId,
                            title: element.label,
                            type: 'item',
                            openInNewTab: true,
                            url: '/pages/content/' + pageLabelId + '/' + navMenuAvailItem.id + '/' + element.id
                        });
                    }
                });
            }
        }
    }
}
